module.exports = __webpack_public_path__ + "statics/img/CoreComparison-taoify@2x.966ae96c.png";